import DefaultButton from './Button/Button'
// import uploadIcon from '../assets/icons/uploadIcon.svg'
import FormInput from './Input'
import { useFormik } from 'formik'
import { propertyDetails } from '../validations/PropertyDetails'
import { useEffect, useState } from 'react'
import EstateService from '../api/estate-service'
import { useNavigate, useParams } from 'react-router-dom'
import { EstateDto, PropertyDetailsFormProps, UpdateEstateType } from '../interfaces/estate'
import { showToast } from '../utils/toast'

const PropertyDetailsForm = ({ imageUrls, estateData, onUpdate }: PropertyDetailsFormProps) => {
  const [loading, setLoading] = useState(false)
  const { estateId } = useParams()
  const navigate = useNavigate()

  const [initialValues, setInitialValues] = useState<UpdateEstateType>({
    name: '',
    address: '',
    country: '',
    state: '',
    securityMeasures: '',
    amenities: '',
    surroundingInfrastructures: '',
  })

  useEffect(() => {
    if (estateData) {
      setInitialValues({
        name: estateData.name || '',
        address: estateData.address || '',
        country: estateData.country || '',
        state: estateData.state || '',
        securityMeasures: estateData.securityMeasures || '',
        amenities: estateData.amenities || '',
        surroundingInfrastructures: estateData.surroundingInfrastructures || '',
        urls: estateData.urls || [],
      })
    }
  }, [estateData])

  const formik = useFormik({
  initialValues,
  enableReinitialize: true,
  validationSchema: propertyDetails,

  onSubmit: async (data) => {
    const propertyDetailData = {
      ...data,
      urls: imageUrls,
    }

    setLoading(true)

    try {
      const response = await EstateService.updateEstate(
        estateId as string,
        propertyDetailData
      )

      showToast({
        description: response.message,
        status: 'success',
      })

      const updatedEstateResponse = await EstateService.getEstateById( estateId as string )

      onUpdate(updatedEstateResponse.data as EstateDto)
    } catch (error) {
      showToast({
        description: 'Failed to update estate',
        status: 'error',
      })
    } finally {
      setLoading(false)
    }
  },
})
  return (
    <form onSubmit={formik.handleSubmit} className="space-y-4 md:space-y-8 w-full">
      <div className="grid gap-6 md:grid-cols-2">
        <FormInput
          placeholder="Amen Estate"
          size="lg"
          value={formik.values.name}
          onChange={formik.handleChange}
          type="text"
          label="Estate name"
          name="name"
        />
        <FormInput
          placeholder="Captain John Street, Close 5, Amen Estate"
          size="lg"
          label="Estate address"
          value={formik.values.address}
          onChange={formik.handleChange}
          type="text"
          name="address"
        />
      </div>
      <div className="grid gap-6 md:grid-cols-2">
        <FormInput
          placeholder="Nigeria"
          size="lg"
          type="text"
          value={formik.values.country}
          onChange={formik.handleChange}
          label="Country"
          name="country"
        />
        <FormInput
          placeholder="Lagos"
          size="lg"
          label="State"
          name="state"
          type="text"
          value={formik.values.state}
          onChange={formik.handleChange}
        />
      </div>
      <div className="space-y-6 md:space-y-8">
        <div className="flex flex-col gap-4">
          <label htmlFor="security" className="text-lg font-medium">
            Security measures
          </label>
          <textarea
            name="securityMeasures"
            id="security"
            value={formik.values.securityMeasures}
            onChange={formik.handleChange}
            rows={4}
            className="w-full border rounded-lg p-4 h-24 md:h-32"
            placeholder="Describe the security measures"
          />
        </div>
        <div className="flex flex-col gap-4">
          <label htmlFor="amenities" className="text-lg font-medium">
            Amenities
          </label>
          <textarea
            name="amenities"
            id="amenities"
            value={formik.values.amenities}
            onChange={formik.handleChange}
            className="w-full border rounded-lg p-4 h-24 md:h-32"
            placeholder="List the amenities"
          />
        </div>
        <div className="flex flex-col gap-4">
          <label htmlFor="infrastructure" className="text-lg font-medium">
            Surrounding infrastructure
          </label>
          <textarea
            name="surroundingInfrastructures"
            id="infrastructure"
            value={formik.values.surroundingInfrastructures}
            onChange={formik.handleChange}
            className="w-full border rounded-lg p-4 h-24 md:h-32"
            placeholder="Describe the surrounding infrastructure"
          />
        </div>
      </div>
      {/* <div>
        <p className="text-lg font-bold mb-6">Property documents</p>
        <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {propertyDocuments.map((item) => (
            <div className="relative" key={item.id}>
              <label
                title="Click to upload"
                htmlFor={item.id}
                className="cursor-pointer flex items-center gap-4 p-4 border rounded-lg hover:bg-gray-100"
                onClick={() => alert('The upload feature is not available now.')}
              >
                <div className="flex items-center justify-center bg-black h-10 w-10 rounded-lg">
                  <img src={uploadIcon} alt="file upload icon" />
                </div>
                <span className="block text-base font-medium">{item.label}</span>
              </label>
              <input
                type="file"
                name={`${item.id}Document`}
                id={item.id}
                className="hidden"
              />
            </div>
          ))}
        </div>
      </div> */}
      <div className="flex justify-end gap-4">
        <DefaultButton
          color="black"
          border="none"
          buttonType="secondary"
          size="lg"
          onClick={() => navigate('/estates')}
          text="Cancel"
        />
        <DefaultButton
          background="gray.900"
          color="white"
          type="submit"
          size="lg"
          loading={loading}
          text="Save"
        />
      </div>
    </form>
  )
}

export default PropertyDetailsForm
